import { z } from "zod";
import { SectionSpacingSchema } from "../../../../../zod/shared-schemas.mjs";
const FeatureSectionCarouselButtonItemBgImageSchema = z.object({
  alt: z.string().optional().nullable(),
  largeDesktop: z.object({
    src: z.string().optional().nullable()
  }).optional().nullable(),
  desktop: z.object({
    src: z.string().optional().nullable()
  }).optional().nullable(),
  mobile: z.object({
    src: z.string().optional().nullable()
  }).optional().nullable()
});
const FeatureSectionCarouselButtonItemSchema = z.object({
  title: z.string(),
  description: z.string(),
  link: z.object({
    src: z.string(),
    text: z.string().optional().nullable()
  }).optional().nullable(),
  image: z.string().optional().nullable(),
  alt: z.string().optional().nullable(),
  bgImage: FeatureSectionCarouselButtonItemBgImageSchema.optional().nullable(),
  color: z.enum([
    "gray",
    "red",
    "yellow",
    "blue",
    "black",
    "white",
    "blue-gray"
  ]),
  accentColor: z.enum(["red", "yellow", "aqua", "blue", "pink", "gray"]).optional().nullable()
});
const FeatureSectionCarouselButtonSchema = z.object({
  id: z.string().optional().nullable(),
  items: FeatureSectionCarouselButtonItemSchema.array(),
  variant: z.enum(["light"]).optional().nullable()
}).merge(SectionSpacingSchema);
export default FeatureSectionCarouselButtonSchema;
